"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxiosRetryInterceptor = exports.AxiosRetry = void 0;
class AxiosRetry {
    retry(service, err) {
        const config = err === null || err === void 0 ? void 0 : err.config;
        config._retryCount = config._retryCount || 0;
        config._retryCount += 1;
        // delete config.headers;
        setTimeout(() => {
            service.request(config);
        }, 100);
    }
}
exports.AxiosRetry = AxiosRetry;
class AxiosRetryInterceptor {
    constructor(axiosInstance, config) {
        this.axiosInstance = axiosInstance;
        this.config = config;
    }
    setupInterceptor() {
        this.addResponseInterceptor();
    }
    addResponseInterceptor() {
        this.axiosInstance.registerResponseInterceptor(undefined, (error) => {
            var _a, _b, _c;
            const { config, response } = error;
            if (config.retry && error.code !== 'ERR_CANCELED') {
                const maxRetries = (_a = this.config.retryCount) !== null && _a !== void 0 ? _a : 3;
                const retryableStatusCodes = (_b = this.config.retryStatusCodes) !== null && _b !== void 0 ? _b : [
                    500, 502, 503, 504,
                ];
                const isNext = retryableStatusCodes.includes((_c = response === null || response === void 0 ? void 0 : response.status) !== null && _c !== void 0 ? _c : -1) &&
                    (error.config._retryCount || 0) < maxRetries;
                if (isNext || ['ECONNABORTED'].includes(response === null || response === void 0 ? void 0 : response.code)) {
                    const axiosRetry = new AxiosRetry();
                    axiosRetry.retry(this.axiosInstance, error);
                    return;
                }
                return Promise.reject(error);
            }
            return Promise.reject(error);
        });
    }
}
exports.AxiosRetryInterceptor = AxiosRetryInterceptor;
//# sourceMappingURL=AxiosRetryInterceptor.js.map